import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlataformaPagamentoService } from './plataforma-pagamento.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-plataforma-pagamento',
  templateUrl: './plataforma-pagamento.component.html',
  styleUrls: ['./plataforma-pagamento.component.scss']
})
export class PlataformaPagamentoComponent implements OnInit {

  public formTermoPagto: FormGroup = null;
  public listStatus = null;
  public dataLocalUrl = null;
  public isAceiteTermo = false;
  public idProduto = null;
  public cnpj = null;
  public isBtnAceite = false;
  public isBtnVoltar = false;
  public tarAgiliza = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private service: PlataformaPagamentoService,
    private notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private encriptyService: EncriptyUtilService,
  ) {

    this.spinnerService.show();

    this.service.generatebase64(null, (response => {

      this.spinnerService.hide();
      if (response) {
        this.dataLocalUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + response.response);
      }

    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.cnpj = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-enterprise-federal-id'));
    this.idProduto = this.encriptyService.decriptyBySecretKey(localStorage.getItem('bway-product-id'));
    let params = new HttpParams();

    if (this.idProduto != null) {
      params = params.append('idProduct', this.idProduto)
    }

    if (this.cnpj != null) {
      params = params.append('cnpj', this.cnpj)
    }

    this.service.taxasTermos(
      params,
      (response) => {

        if (response == true) {
          this.isAceiteTermo = true;
          this.isBtnVoltar = true;
        } else if (response == false) {
          this.isAceiteTermo = false;
          this.isBtnAceite = true;
          this.isBtnVoltar = false;
        }

      }, (error) => {
        this.notificationService.error(error.response.msgRetorno);
      });

    this.buscaTaxa();

  }

  buscaTaxa() {
    this.service.buscarTaxaAgiliza(null, (response) => {
      this.tarAgiliza = response;
    }, null)
  }

  termoCondicao(data) {

    let params = new HttpParams();

    if (this.idProduto != null) {
      params = params.append('idProduct', this.idProduto)
    }

    if (this.cnpj != null) {
      params = params.append('cnpj', this.cnpj)
    }

    if (data == 'Não Aceito') {
      params = params.append('aceiteTermo', 'N')
    } else if (data == 'Lido e Aceito') {
      params = params.append('aceiteTermo', 'S')
    }

    this.service.aceiteTermo(
      params,
      (response) => {

        this.previousPage();

      }, (error) => {
        this.notificationService.error(error.response.msgRetorno);
      });

  }

  viewVoltar() {
    this.previousPage();
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
